<template>
  <div class="price-container">
    <span
      v-if="originalPrice"
      class="original-price"
      :class="{
        'sales-price': isOnSale,
        'headline-m': !isOnSale,
      }"
    >
      {{ originalPrice }}
    </span>
    <span v-if="isOnSale" class="headline-m sales-price">
      {{ salesPrice }}
    </span>
    <span v-if="isOnSale" class="headline-m sales-text">({{ salesText }})</span>
    <span class="headline-m open-text">{{ openText }}</span>
  </div>
</template>

<script setup lang="ts">
import type { PriceProps } from './types'
import { computed } from 'vue'
const props = withDefaults(defineProps<PriceProps>(), {
  originalPrice: '',
  salesText: '',
  salesPrice: '',
  openText: '',
})

const isOnSale = computed(() => !!props.salesPrice && !!props.salesText)
</script>

<style lang="scss" scoped>
.price-container {
  > * {
    &:not(:last-child) {
      margin-right: 4px;
    }
  }

  .open-text {
    font-weight: var(--size-typography-weight-bold);
  }

  .original-price {
    font-weight: var(--size-typography-weight-bold);
    &.sales-price {
      text-decoration: line-through;
      font-weight: var(--size-typography-weight-book);
    }
  }

  .sales-price {
    font-weight: var(--size-typography-weight-bold);
  }

  .sales-text {
    text-transform: uppercase;
    font-weight: var(--size-typography-weight-bold);
    color: var(--color-base-red-n100);
  }
}
</style>
